<template>
  <button
      class="relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs"
      aria-label="Toggle QR Code"
      type="button"
      @click="openConfirmation"
  >
      <QrCodeIcon class="w-5 h-5 text-lg "/>
  </button>
  <TransitionRoot :show="isOpen" as="template">
    <Dialog as="div" class="relative z-10" @close="closeConfirmation">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                       leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"/>
      </TransitionChild>

      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
                           enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                           enter-to="opacity-100 translate-y-0 sm:scale-100" 
                           leave="ease-in duration-200"
                           leave-from="opacity-100 translate-y-0 sm:scale-100"
                           leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
                class="relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
              <div>
                  <div class="flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full">
                      <QrCodeIcon class="w-5 h-5 text-lg "/>
                  </div>
                  <div class="mt-3 text-center sm:mt-5">
                      <div class="mt-2 text-center">
                          <QrcodeVue style="margin: auto" :value="url" :size="300" level="H" />
                          <p class="mt-5 text-sm text-clay-800">
                              Scan this QR code with your phone
                          </p>
                      </div>
                  </div>
              </div>
                <div class="mt-5 sm:mt-6">
                    <button aria-label="Close" 
                            @click.prevent="closeConfirmation"
                            type="button"
                            class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-clay-600 border border-transparent rounded-md shadow-sm hover:bg-clay-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-clay-500 sm:text-sm">
                        Close
                    </button>
                </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>


<script lang="ts" setup>
// @ts-ignore
import {defineProps, ref} from 'vue';
import QrcodeVue from 'qrcode.vue'
import {QrCodeIcon} from '@heroicons/vue/24/outline';

import {Dialog, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue';

const props = defineProps({
    url: String,
    title: String
})

const isOpen = ref(false);

const openConfirmation = async () => {
  isOpen.value = true;
}

const closeConfirmation = async () => {
  isOpen.value = false;
}
</script>